import React, { useEffect, useState } from "react";
import PhoneIcn from "../../assets/img/phone-icn.png";
import socket from "../../assets/socketConnection";
import {
  ContainerStyled,
  BoxStyled,
  HeaderStyled,
  HeaderText,
  AddTicket,
  CallAndTicketContainer,
  CallBtn,
} from "./suport.styles";
import QuestionsItem from "../../containerSmall/questionsItem/questionsItem.component";
import Tickets from "../../containerSmall/tickets/tickets.component";
import NewTicket from "../../containerSmall/newTicket/newTicket.component";
const Support = () => {
  const [questions, setQuestions] = useState();
  const [tickets, setTickets] = useState();
  const [showTickets, setShowTickets] = useState(false);
  useEffect(() => {
    socket.emit("get_questions", { target: "members" });
    socket.on("response_questions", (questions) => {
      setQuestions(questions);
      console.log("ques", questions);
    });
    socket.emit("get_my_tickets", {});
    socket.on("response_my_tickets", (tickets) => {
      setTickets(tickets);
      console.log("tickets", tickets);
    });
  }, []);
  return (
    <>
      <ContainerStyled>
        <BoxStyled>
          {!showTickets ? (
            <>
              {tickets?.map((ticket) => (
                <Tickets ticket={ticket} />
              ))}
              <HeaderStyled>
                <HeaderText>سوالات متداول</HeaderText>
                <CallAndTicketContainer>
                  <CallBtn
                    onClick={() => (window.location.href = "tel:+982191004733")}
                  >
                    <img style={{ width: "24px" }} src={PhoneIcn} alt="icon" />
                  </CallBtn>
                  <AddTicket onClick={() => setShowTickets(true)}>
                    ایحاد تیکت
                  </AddTicket>
                </CallAndTicketContainer>
              </HeaderStyled>
              {questions?.map((q) => (
                <QuestionsItem questions={q} />
              ))}
            </>
          ) : (
            <NewTicket setShowTickets={setShowTickets}/>
          )}
        </BoxStyled>
      </ContainerStyled>
    </>
  );
};

export default Support;
